'use client'

import { buildHomeOneApiAxiosInstance } from '../../api'
import { type PublicGlobalConfig } from '../../global-config'
import { urlResolverGetRegistrationTypeApiEndpoint } from '../../url-handling'
import { type RegistrationType } from '../consts'

type CustomerRegistrationType = {
  registrationType: RegistrationType
}

const CUSTOMER_REGISTRATION_TYPE_TIMEOUT_MILLIS = 7000

export const userApiGetCustomerRegistrationType = async (
  config: PublicGlobalConfig,
): Promise<CustomerRegistrationType | undefined> => {
  const response = await buildHomeOneApiAxiosInstance(
    config,
  ).get<CustomerRegistrationType>(
    urlResolverGetRegistrationTypeApiEndpoint(config),
    {
      timeout: CUSTOMER_REGISTRATION_TYPE_TIMEOUT_MILLIS,
    },
  )

  return response.data
}
